﻿{
  "version": 1,
  "gameId": "hokm",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "hokm.rules.navigationLabel",
    "kickerKey": "hokm.rules.kicker",
    "titleKey": "hokm.rules.title",
    "summaryKey": "hokm.rules.summary",
    "sections": [
      { "id": "teams", "key": "hokm.rules.teams" },
      { "id": "hakem", "key": "hokm.rules.hakem" },
      { "id": "follow", "key": "hokm.rules.follow" },
      { "id": "trick", "key": "hokm.rules.trick" },
      { "id": "hand", "key": "hokm.rules.hand" },
      { "id": "match", "key": "hokm.rules.match" }
    ],
    "settingsAccess": false
  },
  "cosmetics": { "sharedCardCatalog": true }
}
